export default "__VITE_ASSET__CTXD9NAV__"